export const DIRECTORY_DB = "local-directory";